import { set } from 'vue'

export const state = () => {
  return {
    likes: []
  }
}

export const getters = {
  getLiked: (state) => {
    return (themeId) => {
      if (state.likes) {
        const like = state.likes.find(like => like.id === themeId)

        if (like && like.pivot) {
          return like.pivot.liked
        }

        return null
      }
    }
  }
}

export const mutations = {
  SET_LIKES (state, likes) {
    state.likes = likes
  },
  SET_LIKE (state, likes) {
    for (const like of likes) {
      const currentLike = state.likes.findIndex(stateLike => stateLike.id === like.id)

      if (currentLike >= 0) {
        set(state.likes, currentLike, like)
      } else {
        state.likes.push(like)
      }
    }
  }
}

export const actions = {
  async getLikedThemes ({ commit, rootGetters }) {
    if (!this.$auth.loggedIn) {
      return
    }

    try {
      const likedThemes = await this.$axios.get(`v1/users/${rootGetters['user/currentId']}/liked-themes/`)

      if (likedThemes && likedThemes.data) {
        commit('SET_LIKES', likedThemes.data)
      }
    } catch (e) {
    }
  },
  async likeTheme ({ commit, dispatch, getters, rootGetters, state }, { themeId, liked }) {
    if (!this.$auth.loggedIn) {
      return
    }

    try {
      const { data } = await this.$axios.post(`v1/users/${rootGetters['user/currentId']}/liked-themes/`, {
        theme_id: themeId,
        liked
      })

      commit('SET_LIKE', data)
    } catch (e) {
      return false
    }
  }
}
